import constant from "../../util/constant";
import {
  PARTNER_EVENT_TYPE_API_REQUEST,
  PARTNER_EVENT_TYPE_API_END,
  ADD_EVENT_TYPE_SUCCESS,
  ADD_EVENT_TYPE_FAILURE,
  GET_PARTNER_EVENT_TYPES_SUCCESS,
  GET_PARTNER_EVENT_TYPES_FAILURE,
  UPDATE_EVENT_TYPE_SUCCESS,
  UPDATE_EVENT_TYPE_FAILURE,
  GET_PARTNER_EVENT_TYPE_DETAIL_SUCCESS,
  GET_PARTNER_EVENT_TYPE_DETAIL_FAILURE
} from "../actionTypes";

const { API_STATUS } = constant;

const DEFAULT_STATE = {
  loading: false,
  message: "",
  status: "",
  apiType: "",
  partnerEventTypes: { eventTypes: [], meta: "" },
  partnerEventTypeDetail: {},
};

const partnerEventType = ( state = DEFAULT_STATE, action = "" ) => {
  switch ( action.type ) {
    case PARTNER_EVENT_TYPE_API_REQUEST:
      return {
        ...state,
        status: API_STATUS.START,
        apiType: action.payload,
      };
    case PARTNER_EVENT_TYPE_API_END:
      return {
        ...state,
        status: API_STATUS.END,
        apiType: "",
      };
    case ADD_EVENT_TYPE_SUCCESS:
    case UPDATE_EVENT_TYPE_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
      };
    case ADD_EVENT_TYPE_FAILURE:
    case GET_PARTNER_EVENT_TYPE_DETAIL_FAILURE:
    case UPDATE_EVENT_TYPE_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
      };
    case GET_PARTNER_EVENT_TYPES_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        partnerEventTypes: { eventTypes: [], meta: "" },
      };
    case GET_PARTNER_EVENT_TYPES_SUCCESS:
      return {
        ...state,
        partnerEventTypes: {
          eventTypes:
            action.payload.meta.page === 1
              ? action.payload.dataList
              : [ ...state.partnerEventTypes.eventTypes, ...action.payload.dataList ],
          meta: action.payload.meta,
        },
        status: API_STATUS.SUCCESS,
      };
    case GET_PARTNER_EVENT_TYPE_DETAIL_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        partnerEventTypeDetail: action.payload,
      };
    default:
      return state;
  }
};

export default partnerEventType;
